import styled from 'styled-components';

export const StyledRichText = styled.div`
    ol,
    ul {
        list-style: revert;
        padding: revert;
    }
`;
